import { useEffect } from "react";
import Farmer from '../table/Tablecustomer';
import Modal from "../modal/Modaladdcustomer"



const Dashboard = () => {
  useEffect(() => {
    // getPromise(["sales", "purchases"]);
  }, []);


  return (
    <>
    <Modal/>
    <Farmer/>
    
     
     </>
  );
};

export default Dashboard;
